<template>
  <!-- NOTE (TEMPLATE) to show the specific proposal page -->

  <div>
    <!-- loading component -->
    <Loading />
    <Elite role="researcher" />
  </div>
</template>

<script>
const Elite = () => import("../../components/Elite");

export default {
  components: {
    Elite // NOTE (c-proposal) component of proposal
  },
  data() {
    return {};
  },
  mounted() {
    // NOTE (MOUNTED) to show loading at the beginning
    // this.$bvModal.show("loading");
  }
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #d6bbc0;
  border-bottom: 1px solid #c8ced3;
}
.color {
  background-color: #0c4961;
  color: white;
}
</style>
